import i18n from '@app/localization/i18n';

export const ALL_LOTTERIES_INDEX = -1;
export const ALL_SYSTEMS_SLUG = i18n.t('all');
export const ALL_LOTTERIES = `${i18n.t('all lottery')}`;
export const NO_FILTER = () => true;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/shared/lotto/filter/common.ts